module.exports = __webpack_public_path__ + "static/media/link_icon.5ac6f78d.svg";